import script from "./KPIList.vue?vue&type=script&setup=true&lang=js"
export * from "./KPIList.vue?vue&type=script&setup=true&lang=js"

import "./KPIList.vue?vue&type=style&index=0&id=dd92bf68&lang=scss&scoped=true"

import exportComponent from "/Users/pontiroli/Desktop/Repositories/eni/dist/eni-dist-eni-for-2022-hub-e-longform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dd92bf68"]])

export default __exports__